/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { every as _every } from 'lodash';
import * as Yup from 'yup';

import { aclAddressRegExp } from '../../../../../../../../constants/regExps';
import { PgHbaAuthenticationMethod } from '../../../../../../../../types/cluster/PgHba/PgHbaAuthenticationMethod';
import { PgHbaConnectionTypes } from '../../../../../../../../types/cluster/PgHba/PgHbaConnectionTypes';

export const connectionTypes = Object.values(PgHbaConnectionTypes);
export const authMethods = Object.values(PgHbaAuthenticationMethod);

export const validationSchema = Yup.object().shape({
  type: Yup.string().required('empty'),
  database: Yup.array()
    .of(Yup.string())
    .test('array of databases', 'not_valid', function (value) {
      return _every(value, value => !/["]/.test(value));
    })
    .required('empty'),
  user: Yup.array()
    .of(Yup.string())
    .test('array of users', 'not_valid', function (value) {
      return _every(value, value => !/["]/.test(value));
    })
    .required('empty'),
  address: Yup.string().trim().required('empty').matches(aclAddressRegExp, 'not_valid'),
});

export const validationSchemaIsQuotes = Yup.string().test('is double quotes', 'not_valid', function (value) {
  return !/["]/.test(value);
});
